import React, {Component} from 'react';

export default class MainHeader extends Component {
    render() {
        let {title, description, backgroundImageURL, moreInfoURL, onClickMoreInfo} = this.props;
        return (
            <div className="MainHeader">
                <div className="TitleContainer">
                    <h1 className="Title">{title}</h1>
                    <p className="Description">{description}</p>
                    <div className="ButtonContainer">
                        <div title={moreInfoURL} onClick={ () => {
                            onClickMoreInfo && onClickMoreInfo(moreInfoURL); 
                        }}>
                            More Info
                        </div>
                    </div>
	            </div>
                <div className="ImageContainer"> 
                    <img src={backgroundImageURL} alt="" itemProp="image" />
                </div>
            </div>
        );
    }
}